var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._b({staticClass:"search-button",on:{"click":_vm.onClick}},'button',_vm.$attrs,false),[(!_vm.opened)?_c('adm-symbol',{attrs:{"name":"search_24px"}}):_c('adm-symbol',{attrs:{"name":"close_24px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }